const VALIDATE_STATUSES = [
  "success",
  "warning",
  "error",
  "validating"
];
export { VALIDATE_STATUSES };
